import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router"

import { SessionExpired } from "#pages/login/session-expired.tsx"

export const Route = createFileRoute("/_auth/session-expired")({
  beforeLoad: ({ context }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({ to: "/" })
    }
  },
  component: SessionExpiredPage,
})

function SessionExpiredPage() {
  const navigate = useNavigate()

  return <SessionExpired onSendLink={() => void navigate({ to: "/sign-in" })} />
}
